export default __webpack_public_path__ + "static/media/4fe94f2e-7892-4785-9663-0350a7adf8c0.2cb6f802.woff";